<template>
  <div v-if="evaluation">
    <h1 class="common__main-title">Tutor Evaluation Details</h1>
    <div class="common__sub-title">
      <span>Details</span>
      <span class="common__sub-title-tag">Update</span>
    </div>
    <div class="tutor-info-content">
      <div>
        <p>Tuter Name</p>
        <h2 class="tutor-name">{{evaluation.tutorName}}</h2>
      </div>
      <span class="tutor-info">
        {{evaluation.tutorId}}
        {{evaluation.position}}
        {{evaluation.hireDate | hireDate}}
      </span>
    </div>
    <div class="common__main-contener">
      <div>Score Breakdown</div>
      <b-container class="search-area" fluid="lg">
        <b-form-row class="mb-3">
          <b-col cols="6">
            <div class="d-flex flex-column justify-content-between h-100">
              <div>
                <div class="mb-3">
                  Year: <span>{{evaluation.fiscalYear}}</span>
                </div>
                <div>
                  Tutor Evaluation Score:
                  <span class="font-big">{{evaluation.totalScore}}</span>
                </div>
              </div>
              <div>
                Tutor Evaluation Score Median:
                <span class="font-big">{{evaluation.medianTotalScore}}</span>
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="score-box font-weigth-bold">
              <div>Lesson Observation (Total)</div>
              <div>{{evaluation.observationTotalScore}}/50</div>
            </div>
            <div class="score-box">
              <div>Observation:</div>
              <div>{{evaluation.observationScore}}/40</div>
            </div>
            <div class="score-box">
              <div>Submission of Observation forms:</div>
              <div>{{evaluation.observationFormScore}}/10</div>
            </div>
            <div class="score-box font-weigth-bold">
              <div>Administrative Duties (Total)</div>
              <div>{{evaluation.administrativeDutiesTotalScore}}/25</div>
            </div>
            <div class="score-box">
              <div>Comments:</div>
              <div>{{evaluation.commentScore}}/5</div>
            </div>
            <div class="score-box">
              <div>Review Sheets:</div>
              <div>{{evaluation.reviewSheetScore}}/5</div>
            </div>
            <div class="score-box">
              <div>Deadlines:</div>
              <div>{{evaluation.deadlineScore}}/5</div>
            </div>
            <div class="score-box">
              <div>Lesson Review tasks:</div>
              <div>{{evaluation.lessonReviewTaskScore}}/5</div>
            </div>
            <div class="score-box">
              <div>Student Inquiries:</div>
              <div>{{evaluation.studentInquiryScore}}/5</div>
            </div>
            <div class="score-box font-weigth-bold">
              <div>Performance</div>
              <div>{{evaluation.performanceScore}}/25</div>
            </div>
            <div class="score-box mb-0 font-weigth-bold">
              <div>Attendance (deductions only)</div>
              <div>{{evaluation.attendanceScore}}</div>
            </div>
          </b-col>
        </b-form-row>
      </b-container>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{name:'Evaluations'}"
        >
          Back
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Loading from '@/components/parts/modal/Loading.vue';
import _ from 'lodash';
import { Moment } from 'moment'

@Component({
  components: {
    Loading,
  },

  filters: {
    hireDate: (date: Moment) => date.format('YYYY/MM/DD'),
  },
})

export default class EvaluationDetail extends Vue {
  private isLoading: boolean = false

  private async created() {
    this.isLoading = true;
    try {
      await this.$store.dispatch('getEvaluation', {
        tutorId: this.$route.params.tutorId,
        fiscalYear: this.$route.params.fiscalYear,
      })
    } catch (error: any) {
      this.isLoading = false;
      const message = error.response?.data?.message || error
      await this.$bvModal.msgBoxOk(`Error - ${message}`)
      this.$router.push({ name: 'Evaluations' })
    }
    this.isLoading = false
  }

  private get evaluation() {
    return this.$store.getters.getEvaluationByTutorId(this.$route.params.tutorId)
  }
}
</script>

<style scoped>
.main-content {
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
}

.tutor-info-content {
  background: #D8D8D8;
  padding:40px 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tutor-name {
  line-height: 25px;
  font-size:25px;
  margin-bottom:10px;
}

.tutor-info {
  padding: 5px 10px;
  border-radius: 20px;
  background: #2E75B5;
  color: #fff;
}

.tutor-content p {
  text-align: left;
  margin-bottom: 5px;
}

.score-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px
}

.font-big {
  font-size: 20px;
}

.font-weigth-bold {
  font-weight: bold;
}

</style>
